module.exports = __webpack_public_path__ + "img/read1.58252f04.png";